import Cookies from "js-cookie";
import string from "../utils/strings";

function setToken(token) {
  Cookies.set(string.accessToken, token, { expires: 7 });
}

function getToken() {
  let token = Cookies.get(string.accessToken);
  return token;
}

function setLoginTime(loginTime) {
  Cookies.set(string.loginTime, loginTime, { expires: 7 });
}

function getLoginTime() {
  let loginTime = Cookies.get(string.loginTime);
  return loginTime;
}

function setClearTime(clearTime) {
  Cookies.set(string.clearTime, clearTime, { expires: 7 });
}

function getClearTime() {
  let clearTime = Cookies.get(string.clearTime);
  return clearTime;
}

function setAdminName(adminName) {
  Cookies.set(string.adminName, adminName, { expires: 7 });
}

function getAdminName() {
  let adminName = Cookies.get(string.adminName);
  return adminName;
}

function setActiveList(activeList) {
  Cookies.set(string.activeList, activeList, { expires: 7 });
}

function getActiveList() {
  let activeList = Cookies.get(string.activeList);
  return activeList;
}
function setIsAuth(auth) {
  Cookies.set(string.auth, auth, { expires: 7 });
}

function getIsAuth() {
  let activeList = Cookies.get(string.auth);
  return activeList;
}
function setPrivilege(obj) {
   Cookies.set(string.privilege, JSON.stringify(obj), { expires: 7 });
}

function getPrivilege() {
  const raw = Cookies.get(string.privilege);
  if (!raw) return null;
  try {
    return JSON.parse(raw);
  } catch (e) {
    console.error('Failed to parse privilege cookie:', e);
    return null;
  }
}

const authService = {
  setToken,
  setIsAuth,
  getIsAuth,
  getToken,
  setPrivilege,
  getPrivilege,
  setLoginTime,
  getLoginTime,
  setClearTime,
  getClearTime,
  setAdminName,
  getAdminName,
  setActiveList,
  getActiveList
};

export default authService;
